const seanceValueGetter = (params) => params.data.seance_label;

export default seanceValueGetter;